import { render, staticRenderFns } from "./restpwd.vue?vue&type=template&id=eb3680d0&scoped=true&"
import script from "./restpwd.vue?vue&type=script&lang=js&"
export * from "./restpwd.vue?vue&type=script&lang=js&"
import style0 from "./restpwd.vue?vue&type=style&index=0&id=eb3680d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb3680d0",
  null
  
)

export default component.exports